var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 7.5,
    stroke: "#E6E4E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 24C16 19.5817 19.5817 16 24 16H40C44.4183 16 48 19.5817 48 24V40C48 44.4183 44.4183 48 40 48H24C19.5817 48 16 44.4183 16 40V24Z",
    fill: "#0C8CE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.78 28.1139C36.5152 28.0611 36.2983 27.8955 36.1863 27.6587C34.9461 25.0414 32.0712 23.5779 29.1979 24.1076C26.5798 24.5877 24.5275 26.6777 24.0898 29.3093C23.9602 30.0863 23.9698 30.864 24.1162 31.6217C24.1642 31.869 24.0578 32.1442 23.8394 32.3427C22.9232 33.1756 22.3983 34.3622 22.3983 35.5992C22.3983 38.0253 24.3723 40 26.7991 40H35.6006C38.91 40 41.6017 37.3083 41.6017 33.999C41.6017 31.1465 39.5741 28.6708 36.78 28.1139ZM34.4972 33.3644C34.3412 33.5205 34.1364 33.5989 33.9315 33.5989C33.7267 33.5989 33.5219 33.5205 33.3658 33.3644L32 31.9986V35.9993C32 36.4418 31.6415 36.7994 31.1998 36.7994C30.7582 36.7994 30.3997 36.4418 30.3997 35.9993V31.9986L29.0339 33.3644C28.721 33.6773 28.2153 33.6773 27.9025 33.3644C27.5896 33.0516 27.5896 32.5459 27.9025 32.233L30.0685 30.0671C30.3773 29.7582 30.783 29.603 31.1886 29.6006L31.1998 29.5982L31.211 29.6006C31.6175 29.603 32.0224 29.7582 32.3312 30.0671L34.4972 32.233C34.8101 32.5459 34.8101 33.0516 34.4972 33.3644Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadInput);
export default __webpack_public_path__ + "static/media/upload-input.85008a405ef618d45c42a346405dda3a.svg";
export { ForwardRef as ReactComponent };